(function() {
    'use strict';

    angular
        .module('telestatApp')
        .controller('PhoneCallCheckController', PhoneCallCheckController);

    /* Added UIFormAccess
    PhoneCallCheckController.$inject = ['$state', 'PhoneCallCheck', 'PhoneCallCheckSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function PhoneCallCheckController($state, PhoneCallCheck, PhoneCallCheckSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
    */
    PhoneCallCheckController.$inject = ['$state', 'PhoneCallCheck', 'PhoneCallCheckSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'UIFormAccess'];

    function PhoneCallCheckController($state, PhoneCallCheck, PhoneCallCheckSearch, ParseLinks, AlertService, paginationConstants, pagingParams, UIFormAccess) {

        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        /*
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        */
        vm.itemsPerPage = paginationConstants.itemsPerLargePage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.UIFormAccess = UIFormAccess;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                PhoneCallCheckSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                PhoneCallCheck.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                /*
                if (vm.predicate !== 'id') {
                    result.push('id');
                */
                if (vm.predicate !== 'checkTime') {
                    result.push('checkTime,desc');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.phoneCallChecks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            /*
            vm.predicate = 'id';
            vm.reverse = true;
            */
            vm.predicate = 'checkTime';
            vm.reverse = false;
            vm.currentSearch = null;
            vm.transition();
        }
    }
})();
